import globals from'../globals.js';

function menu(){

    const trigger = document.querySelector('.hamburger');
    const nav = document.querySelector('nav');
    const navLinks = nav.querySelectorAll('a');
    
    for (let a = 0; a < navLinks.length; a++) {

        const link = navLinks[a];

        link.addEventListener('click', function(e){
            e.stopPropagation();
            document.body.classList.remove('nav-open');
        });
        
    }

    nav.removeEventListener('click', toggbelmenu);
    nav.addEventListener('click', toggbelmenu);
  
    trigger.removeEventListener('click', toggbelmenu);
    trigger.addEventListener('click', toggbelmenu);

};

function toggbelmenu(){
    if(document.body.classList.contains('nav-open')){
        document.body.classList.remove('nav-open')
    }else{
        document.body.classList.add('nav-open')
    }
}

export default menu;